import { render, staticRenderFns } from "./FrsRouterBackLink.vue?vue&type=template&id=163f774e&scoped=true&lang=html&"
import script from "./FrsRouterBackLink.vue?vue&type=script&lang=js&"
export * from "./FrsRouterBackLink.vue?vue&type=script&lang=js&"
import style0 from "./FrsRouterBackLink.vue?vue&type=style&index=0&id=163f774e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163f774e",
  null
  
)

export default component.exports